import React from "react";

import FixedBottomIcon from "@src/assets/icons/fixedbottom-tech.svg";
import FloatingIcon from "@src/assets/icons/floating-tech.svg";
import HydrogenIcon from "@src/assets/icons/hydrogen.svg";
import { DUALIS_TECHNOLOGY } from "@src/constants";
import "./technologies.less";

interface TechnologiesProps {
  technologies: string;
}

const Technologies: React.FC<TechnologiesProps> = ({ technologies }) => {
  /**
   * Returns the technology name by removing "Hydrogen" from the string.
   *
   * @param {string} technologies - The technology string.
   * @returns The technology name without "Hydrogen".
   */
  function getTechnologyName(technologies: string): string {
    if (!technologies) return "";
    return technologies
      .split(", ")
      .filter((tech) => tech !== DUALIS_TECHNOLOGY.HYDROGEN)
      .join(", ");
  }

  /**
   * Returns the icon for the given technology.
   *
   * @param {string} technologies - The technology string.
   * @returns The icon or null if not found.
   */
  function getTechnologyIcon(technologies: string): React.ReactElement | null {
    if (!technologies) return null;
    if (technologies.includes(DUALIS_TECHNOLOGY.HYDROGEN))
      return (
        <HydrogenIcon
          className="technologies-icon"
          data-testid="hydrogen-icon"
        />
      );
    const technologyName = getTechnologyName(technologies);
    if (technologyName === "Floating")
      return (
        <FloatingIcon
          className="technologies-icon"
          data-testid="floating-icon"
        />
      );
    if (technologyName === "Fixed bottom")
      return (
        <FixedBottomIcon
          className="technologies-icon"
          data-testid="fixed-bottom-icon"
        />
      );
    return null;
  }

  return (
    <div className="technologies">
      {getTechnologyIcon(technologies)}
      <span className="technologies-name">
        {getTechnologyName(technologies)}
      </span>
    </div>
  );
};

export default Technologies;
